module.exports = __webpack_public_path__ + "img/logo.adeae709.svg";